import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface Props {
  images: string[];
  alt: string;
  /** When a variant changes the product image, jump to it. */
  activeImage?: string;
  badges?: React.ReactNode;
}
export function ProductGallery({
  images,
  alt,
  activeImage,
  badges
}: Props) {
  const all = activeImage && !images.includes(activeImage) ? [activeImage, ...images] : images;
  const [current, setCurrent] = useState(activeImage ?? all[0]);
  useEffect(() => {
    if (activeImage) setCurrent(activeImage);
  }, [activeImage]);
  return <div className="flex flex-col-reverse gap-3 md:flex-row" data-id="element-424" data-mp="1phe3akovruw6">
      {all.length > 1 && <ul className="flex gap-2.5 md:flex-col" aria-label="Productafbeeldingen" data-id="element-425" data-mp="1ti7qtcyev7oj">
          {all.map((src, i) => <li key={src} data-id="element-426" data-mp="3junimt43yamc" data-mpi={i}>
              <button type="button" onClick={() => setCurrent(src)} aria-label={`Toon afbeelding ${i + 1}`} aria-current={current === src} className={`block h-16 w-16 overflow-hidden rounded-lg bg-surface transition-shadow duration-150 md:h-20 md:w-20 ${current === src ? 'ring-2 ring-ink' : 'ring-1 ring-line hover:ring-ink/30'}`} data-id="element-427" data-mp="3jvf1r4giqfvq">
                <img src={src} alt="" className="h-full w-full object-cover" data-id="element-428" data-mp="1bku1xe8kl0rn" />
              </button>
            </li>)}
        </ul>}
      <div className="relative aspect-square flex-1 overflow-hidden rounded-2xl bg-surface" data-id="element-429" data-mp="nxlxeyiytvqo">
        <AnimatePresence initial={false} data-id="element-430" data-mp="iy9bcfzx4sp5">
          <motion.img key={current} src={current} alt={alt} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="absolute inset-0 h-full w-full object-cover" data-id="element-431" data-mp="xu8hhl3gwirn" />
        </AnimatePresence>
        {badges && <div className="absolute left-4 top-4 flex gap-1.5" data-id="element-432" data-mp="2bczi28gc4rqf">{badges}</div>}
      </div>
    </div>;
}